import { render, staticRenderFns } from "./activitySection.vue?vue&type=template&id=055dccef"
import script from "./activitySection.vue?vue&type=script&lang=js"
export * from "./activitySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports